<div class="flex-wrapper">
  <div class="center-page">
    <h1>
      {{ 'rspSigningTitle' | translate }}
      @if (insuredPersonFullName) {
        <br />
        {{ 'rspInsuredPersonText' | translate: { insuredPersonName: insuredPersonFullName } }}
      }
    </h1>
    @if (iframeSrc) {
      <iframe [src]="iframeSrc" id="signFrame" name="E-Ident" title="E-Ident"></iframe>
    }
  </div>
</div>
